import http from 'utils/http';
import { getAgencySynchronizerLogsUrl, getAgencySynchronizedItemsUrl } from './apiUrls';
import { AgencySynchronizerLogsResponse, AgencySynchronizedItemsResponse } from './types';

export function getAgencySynchronizerLogs(params?: Record<string, unknown>): Promise<AgencySynchronizerLogsResponse> {
  return http.get(getAgencySynchronizerLogsUrl(), params);
}

export function getAgencySynchronizedItems(
  synchronizerLogId: number | string,
  params?: Record<string, unknown>
): Promise<AgencySynchronizedItemsResponse> {
  return http.get(getAgencySynchronizedItemsUrl(synchronizerLogId), params);
}
